import type { Atom, WritableAtom } from 'jotai';

export type AtomDevtoolsOptions = {
  isDev?: boolean;
};

/**
 * Configures an atom with debug label and optional mount/unmount tracking.
 * The debug label makes atoms identifiable in Jotai devtools.
 *
 * @example
 * ```ts
 * const myAtom = configureAtomDevtools(
 *   atom(initialValue),
 *   'feature/myAtom',
 *   { isDev: import.meta.env.DEV }
 * );
 * ```
 */
export function configureAtomDevtools<A>(atom: A, label: string, options: AtomDevtoolsOptions = {}): A {
  const { isDev = false } = options;

  (atom as Atom<unknown>).debugLabel = label;

  if (isDev) {
    (atom as WritableAtom<unknown, unknown[], unknown>).onMount = () => {
      console.debug(`[Atom Mount] ${label}`);
      return () => {
        console.debug(`[Atom Unmount] ${label}`);
      };
    };
  }

  return atom;
}
